import ajax from './ajax';
import { API_DOMAIN } from '../utils/constants';
import { getUserToken } from '../utils/userToken';

// A normal navigation uses the awaited API; page teardown needs a keepalive request.
export function revokePaymentOnExit(token) {
  const body = new URLSearchParams({ user_token: getUserToken(), payment_access_token: token });
  return fetch(`${API_DOMAIN}/api/a/revoke-payment-access`, { method: 'POST', body, keepalive: true }).catch(() => {});
}

export async function settingsRequest(endpoint, data = {}) {
  const response = await ajax(`${API_DOMAIN}/api/a/${endpoint}`, data, 'POST', true);
  if (response.status !== 200) throw new Error(response.msg || 'Unable to complete the request.');
  return response.data;
}

export function settingsError(error) {
  const body = error?.response?.data;
  const errors = body?.errors || body?.data?.errors;
  return (errors && Object.values(errors).flat()[0]) || body?.msg || body?.message || error.message || 'Unable to complete the request.';
}
